module.exports = {
  message: {
    header: {
      explore: '立即体验',
      access: '接入文档',
      operation: '运营指南',
    },
    sidebar: {
      home: '主页',
      contactus: '联系我们',
      language: '语言',
    },
    provides: {
      h1: 'MINT变现平台，提供一站式广告变现服务及解决方案',
      p:
        'MINT Mediation接入全球数家主流广告平台，为您提供变现、运营、优化的一站式服务，轻松实现变现收益的最大化',
      started: '立即合作',
      sdk: '获取SDK',
    },
    why: {
      h1: '为什么选择MINT',
      reasons: [
        '<strong>一个SDK</strong>轻松接入多家主流广告平台',
        '灵活设置自动、手动出价模式，<strong>提升变现效率</strong>',
        '精准把控LTV&ROI，<strong>指导营销方案的制定</strong>',
        'Bidding+Waterfall混合竞价模式，<strong>实现广告收益最大化</strong>',
        '分析用户状态、广告浏览等数据，<strong>了解用户真实行为轨迹</strong>',
        '<strong>实时更新</strong>各维度数据，<strong>可视化展示</strong>各数据指标变化趋势',
      ],
    },
    diversified: {
      h1: '支持多样化的广告样式',
      sliderArray: [
        '原生广告',
        '激励视频广告',
        '插屏广告',
        '开屏广告',
        'banner',
      ],
    },
    aggregated: {
      h1: '已聚合平台',
    },
    intelligent: {
      h1: '智能高效的管理后台',
      p:
        'MINT管理后台支持您实时把控产品变现的各个环节，轻松实现应用配置、数据监控、变现优化等操作。',
    },
    managed: {
      h1: '托管式变现运营服务',
      p:
        '随时在线为您提供全方位变现服务支持，运营专家一对一指导产品接入、运营优化，助力您的产品高效成长',
      reasons: [
        '产品对接的各个阶段均有专人支持，保障快速上线',
        '专业变现优化师一对一指导，提供专家级的优化培训',
        '7*24h在线，为您提供运营、技术等全方位支持',
      ],
    },
    excellent: {
      h1: '优秀案例',
    },
    contact: {
      button: '联系我们',
    },
    footer: {
      about: '关于小米',
      advertising: 'Advertising Business',
      miads: 'Mi ads',
      blog: 'Blog',
      contact: '联系方式',
    },
  },
}
